import Report from './report.i18n';

export default Report
export { Report as Base }
